import { HamptonValuationActions, HamptonValuationActionTypes, HamptonValuationUpdateAnalysis } from "../_actions/hampton-valuation.actions"

export const featurekey = 'hampton-valuation'

export interface HamptonValuationState {
  comparableOverview: 'quantitative' | 'qualitative',
  comparableAnalysis: 'quantitative' | 'qualitative',

  comparablesPriceLowerEnd: number
  comparablesPriceHigherEnd: number,
  consultantLower: number,
  consultantHigher: number,
  valuerLower: number,
  valuerHigher: number,
  reasoning: string,
  valueRangeId: number,
  valueEstimated: number,
  rentalValueLower: number,
  rentalValueHigher: number,
  landValue: number
}

export const initialHamptonValuationState: HamptonValuationState = {
  comparableOverview: 'qualitative',
  comparableAnalysis: 'qualitative',

  comparablesPriceLowerEnd: null,
  comparablesPriceHigherEnd: null,
  consultantLower: null,
  consultantHigher: null,
  valuerLower: null,
  valuerHigher: null,
  reasoning: null,
  valueRangeId: null,
  valueEstimated: null,
  rentalValueLower: null,
  rentalValueHigher: null,
  landValue: null
}

export function hamptonValuationReducer(
  state = initialHamptonValuationState,
  action: HamptonValuationActions
): HamptonValuationState {
  switch (action.type) {
    case HamptonValuationActionTypes.ChangeComparableOverview: {
      return {...state, comparableOverview: action.payload.value}
    }
    case HamptonValuationActionTypes.ChangeComparableAnalysis: {
      return {...state, comparableAnalysis: action.payload.value}
    }
    case HamptonValuationActionTypes.UpdateAnalysis: {
      return {...state, ...action.payload}
    }
    case HamptonValuationActionTypes.Reset: {
      return initialHamptonValuationState;
    }
    case HamptonValuationActionTypes.Load: {
      const overview: 'qualitative' | 'quantitative' = action.payload.value.comparable_overview === 'qualitative' ? 'qualitative' : 'quantitative'
      const analysis: 'qualitative' | 'quantitative' = action.payload.value.comparable_analysis === 'qualitative' ? 'qualitative' : 'quantitative'
      return {
        comparableOverview: overview,
        comparableAnalysis: analysis,
        comparablesPriceLowerEnd: action.payload.value.comparable_price_lower_end,
        comparablesPriceHigherEnd: action.payload.value.comparable_price_lower_end,
        consultantLower: action.payload.value.consultant_lower_end,
        consultantHigher: action.payload.value.consultant_higher_end,
        valuerLower: action.payload.value.valuer_lower_end,
        valuerHigher: action.payload.value.value_higher_end,
        valueRangeId: action.payload.value.value_range_id,
        valueEstimated: action.payload.value.value_estimated,
        reasoning: action.payload.value.reasoning,
        rentalValueLower: action.payload.value.rental_value_lower_end,
        rentalValueHigher: action.payload.value.rental_value_higher_end,
        landValue: action.payload.value.land_value
      }
    }
    default:
      return state
  }
}